module.exports = __webpack_public_path__ + "img/ch73.e106827a.png";